import { useState } from "react";
import { Patient } from "../../../utils/api-objects/Patient";
import { ExpertRole, Folder } from "../../../utils/Enums";
import { shouldShowExpert } from "../utils/shouldShowExpert";
import { FolderBox } from "./FolderBox";

const ExpertsBox: React.FC<{ patient: Patient, role: ExpertRole }> = ({ patient, role }) => {
    const experts = [
        {
            data: patient.nutritionist,
            title: "Nutrizionista",
            folder: Folder.Nutritionist,
            show: shouldShowExpert(role, ExpertRole.Nutritionist),
        },
        {
            data: patient.physician,
            title: "Endocrinologo",
            folder: Folder.Physician,
            show: shouldShowExpert(role, ExpertRole.Physician),
        },
    ];

    const [isExpanded, setIsExpanded] = useState(true);

    const handleToggle = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <div className="space-y-[25px] border rounded-xl p-2 border border-solid border-holifya-grey-shadow shadow-platform-new">
            <div className="font-bold text-[16px] leading-[33px] flex justify-between items-center">
                <span>Esperti</span>
                <button
                    onClick={handleToggle}
                    className="text-blue-500 text-sm">
                    {isExpanded ? "Mostra meno" : "Mostra di più"}
                </button>
            </div>
            {isExpanded && experts.map(
                (expert, idx) =>
                    expert.show &&
                    expert.data && (
                        <div
                            key={idx}
                            className="space-y-[10px]"
                        >
                            <div className="font-semibold text-[14px] leading-[20px]">
                                {expert.title}
                            </div>

                            <FolderBox
                                folder={expert.folder}
                                pointer={false}
                                textTwo={`${expert.data.name ?? "null"} ${expert.data.family_name ?? "null"}`}
                                textThree={expert.data.email ?? ""}
                            />
                        </div>
                    )
            )}
        </div>
    )
}

export default ExpertsBox
